import { useEffect, useState } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useToast } from "../../view/components/ui/use-toast";
import { customerService } from "../services/customerService";
import { CustormerParams } from "../services/customerService/customer";

export const useCustomers = ({
  initialLimit,
  userId,
}: {
  initialLimit: number;
  userId?: string;
}) => {
  const [params, setParams] = useState<CustormerParams>({ search: "" });
  const [isInitialFetch, setIsInitialFetch] = useState(true);

  const handleCustomersData = async ({ pageParam = 0 }) => {
    const response = await customerService.customer({
      ...params,
      skip: pageParam,
      limit: isInitialFetch ? initialLimit : 10,
    });

    setIsInitialFetch(false);
    return response;
  };

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isError,
    isFetchingNextPage,
    refetch,
  } = useInfiniteQuery({
    queryKey: ["AllCustomers", params, userId],
    queryFn: handleCustomersData,
    getNextPageParam: (lastPage) => {
      if (
        lastPage.pagination.skip + lastPage.pagination.limit ===
        lastPage.pagination.total / lastPage.pagination.limit
      ) {
        return null;
      }
      return lastPage.pagination.skip + lastPage.pagination.limit;
    },
    initialPageParam: undefined,
  });

  const { toast } = useToast();

  useEffect(() => {
    if (isError) {
      toast({
        variant: "destructive",
        title: "Erro ao carregador os dados, tente novamente mais tarde!",
      });
    }
  }, [isError, toast]);

  return {
    isLoading,
    isFetching,
    data,
    setParams,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  };
};
